import React from 'react';
import "./AudioSliderTooltip.css"
// NORTON DESIGN SYSTEM
import { Tooltip } from '@wwnds/react';

const AudioSliderTooltip = ({ audioSliderRef, tooltipLocation, showTooltip, tooltipLabel }) => {
  return (
    <div className="tooltip-container" style={{ position: "absolute", left: tooltipLocation, display: showTooltip ? 'block' : 'none' }} >
      <Tooltip
        isOpen
        placement="top"
        trigger="mouseenter"
        reference={audioSliderRef}
        baseName="nds-tooltip audio-slider-tooltip"
        bodyClass="audio-slider-tooltip-body"
      >
        {tooltipLabel}
      </Tooltip>
    </div>
  )
}

export default AudioSliderTooltip;